import Vue from 'vue'
import VueCompositionApi from '@vue/composition-api'
import App from './App.vue'
import router from './router'
import store from './store'
import autoSize from '@/directives/autoSize'
import eventHub from '@/utils/eventHub'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import { toTnteger, getLocId } from '@/utils'
import 'normalize.css'
import './style/index.css'
import './style/common.scss'

Vue.prototype.$eventHub = eventHub
Vue.prototype.$toTnteger = toTnteger
Vue.prototype.$getLocId = getLocId
Vue.config.productionTip = false

Vue.use(VueCompositionApi)
Vue.use(ElementUI)

autoSize.init()
new Vue({
    router,
    store,
    render: (h) => h(App)
}).$mount('#app')
